// declare global is used if project is
// module instead of applicationl.
//declare global {
interface Window { torus: any; }
//}
window.torus = window.torus || {};